// 线下明细
import React,{useState,useEffect} from 'react'
import {
  Row,
  Table,
  Select,
  Form,
  Input,
  Button,
  PageHeader
 } from 'antd';
import { withRouter } from "react-router-dom";
import {request} from '../../../../utils/fetch'
import store from '../../../../store/index'

const { Option } = Select;
 const FormItem = Form.Item;
 const itemStyle = {
     width:'300px',
     marginRight:'15px'
}
 const labelStyleObj = {
    labelCol:{ span: 9},
    wrapperCol:{ span: 15}
 }
 const wrapStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '900px'
 }
function SettleQueryDetail(props) {
    let path = 'platform:Settlement'
    const [form] = Form.useForm();
    const {parmObj} = props
    const [tableData,setTableData] = useState([])
    const [resultObj,setResultObj] = useState({})
    const pageSize = 20     //每页条数
    const [total,setTotal] = useState(0)
    const [pageNum,setPageNum] = useState(1)
     
    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            align:'center',
            
        }, {
            title: '身份证号',
            dataIndex: 'idNumber',
            key: 'idNumber',
            width: 150,
            align:'center',
            
        }, {
            title: '收款卡号',
            dataIndex: 'bankNumber',
            key: 'bankNumber',
            width: 150,
            align:'center',
            
        },  {
            title: '开户行',
            dataIndex: 'bankName',
            key: 'bankName',
            width: 150,
            align:'center',
            
        },  {
            title: '打款备注',
            dataIndex: 'content',
            key: 'content',
            width: 150,
            align:'center',
            
        },{
            title: '个人佣金（元）',
            dataIndex: 'commissionAmount',
            key: 'commissionAmount',
            width: 150,
            align:'center',
            
        }, {
            title: '服务费（元）',
            dataIndex: 'serviceAmount',
            key: 'serviceAmount',
            width: 150,
            align:'center',
            
        }, {
            title: '税费（元）',
            dataIndex: 'taxAmount',
            key: 'taxAmount',
            width: 150,
            align:'center',
        },
        {
            title: '状态',
            dataIndex: 'rejectFlagName',
            key: 'rejectFlagName',
            width: 150,
            align:'center',
        },
     
    ];
    //组件渲染函数
    const myComponent = {
        renderSearchForm: () => {
            return (
                <Form form={form} >
                    <Row>
                        <FormItem label="关键字" name="keyword"  style={itemStyle} {...labelStyleObj}>
                            <Input placeholder="姓名丨身份证号丨收款卡号" />
                        </FormItem>
                        <FormItem label="状态" name="rejectFlag"  style={itemStyle} {...labelStyleObj}>
                            <Select>
                                <Option value={1}>已剔除</Option>
                                <Option value={0}>未剔除</Option>
                            </Select>
                        </FormItem>
                        <FormItem style={{ float: 'right', whiteSpace: 'nowrap' }} >
                            <Button type="primary" onClick={methodsFn.handleSearch}>查询</Button>
                            <Button style={{ marginLeft: 10 }} onClick={methodsFn.handleFormReset}>重置</Button>
                            {store.getState().userReducer.permissions.indexOf(`${path}:export`)>-1&&<Button style={{ marginLeft: 10 }} onClick={methodsFn.handleExport}>导出</Button>}
                        </FormItem>
                    </Row>
                </Form>
            );
        },

    }
    //方法函数
    const methodsFn =  {
        getsearchObj(){
            return (
                {
                    type:form.getFieldsValue().type,
                    paymentStatus:form.getFieldsValue().paymentStatus,
                    keyword:form.getFieldsValue().keyword,
                    settlementNo:parmObj.settlementNo,
                    lineType:parmObj.lineType,
                }
            )
        },
        handleSearch() {
            setPageNum(1)
            methodsFn.getTableList(methodsFn.getsearchObj())
        },
        handleFormReset(){
            form.resetFields();
        },
        async getTableList(searchObj){
            let result = await request.get('/platform/settlement/getDetailList',{
                ...searchObj,
                pageSize:pageSize,
                pageNum:pageNum,
            })
               setTotal(result.totalCount)
               setTableData(result.list)
        },
        async getDetailStat(){
            let result = await request.get('/platform/settlement/getDetailStat',{
                settlementNo:parmObj.settlementNo,
            })
            setResultObj(result)
              
        },
        handleExport(){
            request.downExport('/platform/settlement/exportDetail',methodsFn.getsearchObj())
        },
    }
    useEffect(() => {
        methodsFn.getDetailStat()
    },[])
    useEffect(() => {
        methodsFn.getTableList(methodsFn.getsearchObj())
    },[pageNum])

    return (
        <div>
            <PageHeader
                className="site-page-header"
                onBack={props.callFn}
                title="线下明细"
                subTitle=""
            />
                 <div style={{'background': '#fff','margin': '10px 0','padding': '20px'}}>
                <span>状态：{resultObj.paymentStatusName}</span>
                {
                    resultObj.paymentStatusName !== '待平台确认'
                    ?<div>
                    <p style={wrapStyle}>
                        <span>{resultObj.paymentStatusName == '放弃支付'?'放弃':'确认'}操作时间：{resultObj.statusUpdateTime}</span>
                        <span>{resultObj.paymentStatusName == '放弃支付'?'放弃':'确认'}操作人：{resultObj.sureUser}</span>
                    </p>
                    <p style={wrapStyle}>
                        <span>实际放款合计：￥{resultObj.totalAmount}</span>
                        <span>实际放款佣金：￥{resultObj.sureCommissionAmount}</span>
                        <span>实际放款服务费：￥{resultObj.sureServiceAmount}</span>
                        <span>实际放款税费：￥{resultObj.sureTaxAmount}</span>
                        <span>备注：{resultObj.sureRemark}</span>
                        </p>
                    </div>
                    :null
                }
            </div>

            {myComponent.renderSearchForm()}
           <Table 
            scroll={{ x: 'max-content',y: 500 }}
            columns={columns} 
            dataSource={tableData} 
            rowKey={(record) => record.idNumber}
            pagination={{
                position: ['bottomCenter'],
                total: total,
                current: pageNum,
                pageSize: pageSize,
                showSizeChanger:false,
                showTotal:(total) =>  `共 ${total} 条数据` ,
                onChange: (pageNum, pageSize) => setPageNum(pageNum)
            }}
           />

         
        </div>
    )
}

export default withRouter(SettleQueryDetail)
